module.exports = __webpack_public_path__ + "static/media/undraw_festivities.37ee4e28.svg";